import Swiper from "swiper";
import {Navigation, Thumbs, Pagination} from "swiper/modules";

export const sliderGallery = (large: HTMLElement, small: HTMLElement) => {

    // Slider Gallery Buttons
    const prevButton = large.querySelector('.swiper-button-prev') as HTMLElement;
    const nextButton = large.querySelector('.swiper-button-next') as HTMLElement;

    // Slider Gallery Small Image
    const smallSlider = new Swiper(small, {
        modules: [Pagination, Navigation],
        pagination: {
            el: small.querySelector('.swiper-pagination') as HTMLElement,
            clickable: true,
        },
        navigation: false,
        spaceBetween: 16,
        slidesPerView: 2.5,
        freeMode: true,
        breakpoints: {
            550: {
                slidesPerView: 4,
                spaceBetween: 24,
            },
            900: {
                slidesPerView: 3,
                spaceBetween: 24,
            },
            1300: {
                slidesPerView: 5,
                spaceBetween: 24,
            }
        }
    });

    // Slider Gallery Large Image
    new Swiper(large, {
        modules: [Thumbs, Navigation],
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
        spaceBetween: 10,
        thumbs: {
            swiper: smallSlider,
        },
    });    
}
